import {ActionList} from '@primer/react'

import {LinkExternalIcon} from '@primer/octicons-react'

export default function EducationGroup() {
  return (
    <ActionList.LinkItem
      href="https://github.com/search/advanced"
      // can remove when CSS Modules ships for ActionList
      sx={{
        span: {
          color: 'accent.fg',
        },
      }}
      className="fgColor-accent"
    >
      <ActionList.LeadingVisual className="fgColor-accent">
        <LinkExternalIcon />
      </ActionList.LeadingVisual>
      Advanced search
    </ActionList.LinkItem>
  )
}

try{ EducationGroup.displayName ||= 'EducationGroup' } catch {}